var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-h--100"},[_c('Header'),_c('div',{staticClass:"-h--100 -px--0",staticStyle:{"padding-top":"89px","overflow-y":"auto","overflow-x":"hidden"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }